import { jsxs, jsx } from "react/jsx-runtime";
const IconGraphBarSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx("path", { d: "M5 10.833H1.666a.833.833 0 0 0-.833.834v6.666a.833.833 0 0 0 .833.834H5a.833.833 0 0 0 .833-.834v-6.666A.833.833 0 0 0 5 10.833ZM4.166 17.5H2.5v-5h1.666v5Zm14.167-10H15a.833.833 0 0 0-.834.833v10a.833.833 0 0 0 .834.834h3.333a.833.833 0 0 0 .833-.834v-10a.834.834 0 0 0-.833-.833Zm-.833 10h-1.667V9.167H17.5V17.5ZM11.666.833H8.333a.833.833 0 0 0-.833.834v16.666a.833.833 0 0 0 .833.834h3.333a.833.833 0 0 0 .834-.834V1.667a.833.833 0 0 0-.834-.834ZM10.833 17.5H9.166v-15h1.667v15Z" }) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h20v20H0z" }) }) })
    ]
  }
);
export {
  IconGraphBarSvg
};
